import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=7ad498c6&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=7ad498c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad498c6",
  null
  
)

export default component.exports